<template>
  <div>
    <dx-description-label v-if="$te(`${translationKeyPrefix}.description`)">
      {{ $t(`${translationKeyPrefix}.description`) }}
    </dx-description-label>

    <dx-input
      :id="config.id"
      :value="value"
      :label="translatedLabel"
      :type="type"
      :disabled="config.readonly"
      :error="translatedError"
      @input="update"
      @blur="onBlur"
    />
  </div>
</template>

<script>
import { DxInput } from '@sumcumo/dextra-frontend-component-lib'
import DxDescriptionLabel from '~/components/DX-DescriptionLabel/DxDescriptionLabel'

export default {
  name: 'DXNumberAdapter',
  components: {
    DxDescriptionLabel,
    DxInput,
  },
  props: {
    config: {
      type: Object,
      default: () => ({}),
    },
    type: {
      type: String,
      default: 'number',
    },
    value: {
      type: [Number, String],
      default: null,
    },
    error: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {
    translationKeyPrefix() {
      if (this.config.source) {
        if (this.config.source.kind === 'values') {
          return `attributes.${this.config.source.key}.${this.config.source.originalId}`
        }

        return `${this.config.source.key}.${this.config.source.originalId}`
      }

      return ''
    },

    translatedLabel() {
      return this.$t(`${this.translationKeyPrefix}.label`)
    },

    translatedError() {
      return this.error
        ? this.$t(`errors.number.${this.error.type}`, {
            ...this.error.params,
            label: this.translatedLabel,
          })
        : null
    },
  },

  methods: {
    update(newValue) {
      this.$emit('input', newValue)
    },
    onBlur() {
      this.$emit('validate', this.config.id)
    },
  },
}
</script>
